import { Injectable, inject } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { map, Observable } from 'rxjs';
import { FreezeSeatDialogComponent } from './freeze-seat-dialog.component';
import {
	FreezeSeatDialogData,
	FreezeSeatDialogResult
} from './freeze-seat-dialog.model';

@Injectable({ providedIn: 'root' })
export class FreezeSeatDialogService {
	private readonly dialogs = inject(LoDialogService);

	open(
		data: FreezeSeatDialogData,
		opener?: HTMLElement | null
	): Observable<FreezeSeatDialogResult> {
		const ref = this.dialogs.open<
			FreezeSeatDialogComponent,
			FreezeSeatDialogData,
			FreezeSeatDialogResult
		>(FreezeSeatDialogComponent, {
			data,
			opener: opener ?? undefined
		});
		return ref.closed.pipe(map(result => result ?? { confirmed: false }));
	}
}
